import { Box } from '@rsos/base-components';
import styled, { Theme } from '@rsos/theme/styled';

export const IntermediateWrapper = styled(Box).attrs(
  ({ theme, height }: { theme: Theme; height?: number }) => ({
    align: 'center',
    justify: 'center',
    height: height ? `${height}px` : '100%',
    border: `solid 1px ${theme.colors.heavyLineOutline}`,
    borderRadius: '5px',
    mb: 10,
  }),
)``;
